import { TextField } from '@mui/material';

type LastNameInputProps = {
  value: string;
  onChange: (value: string) => void;
};

export function LastNameInput({ value, onChange }: LastNameInputProps) {
  return (
    <TextField
      type='text'
      label='Nachname'
      required
      fullWidth
      size='small'
      value={value}
      onChange={event => onChange(event.target.value)}
    />
  );
}
